export default "__VITE_ASSET__D0jqQsh$__"